import axios from "axios";
import BASE_URL from "../../config";

// Get the auth token from localStorage and return headers
const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

// Get user ID from session
const getUserId = () => {
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  return authUser.userId || 1;
};

// API to fetch restaurant tables with optional filters
export const getRestaurantTables = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/RestaurantTable/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching restaurant tables:", error);
    throw error;
  }
};

// API to insert or update a restaurant table
export const saveRestaurantTable = async (tableData) => {
  const userId = getUserId();
  const response = await axios.post(
    `${BASE_URL}/api/RestaurantTable/save?modifiedByUserId=${userId}`,
    tableData,
    {
      headers: getAuthHeader(),
    }
  );
  return response.data;
};
